import type { DirectMpTargetViewState } from "./directMpTargetViewState";
import type { MpSlotChargeController } from "./mpSlotChargeController";

export interface DirectMpSlotNodes {
  readonly element: HTMLDivElement;
  readonly controller: MpSlotChargeController;
}

export function syncDirectMpSlot(
  nodes: DirectMpSlotNodes,
  state: DirectMpTargetViewState | null,
): void {
  const { element, controller } = nodes;
  element.hidden = state === null || !state.showSlot;
  element.dataset.mpAssigned = String(state?.assigned ?? false);
  element.dataset.mpOperative = String(state?.operative ?? false);
  element.dataset.mpBlocked = String(state?.mpBlocked ?? false);
  element.dataset.paused = String(state?.showPauseOverlay ?? false);
  element.dataset.blocked = String(state?.mpBlocked ?? false);
  if (state?.mpBlockedReason !== undefined) {
    element.dataset.mpBlockedReason = state.mpBlockedReason;
  } else {
    delete element.dataset.mpBlockedReason;
  }
  if (element.dataset.mpScope === "wall") {
    element.setAttribute("aria-pressed", String(state?.assigned ?? false));
  }
  if (element.hidden) controller.clearPointerHover();
  controller.sync({
    isAssigned: state?.assigned ?? false,
    canAssign: !element.hidden && (state?.canAssign ?? false),
    canRemove: !element.hidden && (state?.canRemove ?? false),
  });
}
